import { BaseModel } from './BaseModel';
import { ScheduleTask } from './ScheduleTask';

export interface ScheduleCondition {
    type: string;
    operator: string;
    value: string | number;
}

export class Schedule extends BaseModel {
    public id = -1;
    public name = '';
    public cron = {
        minute: '',
        hour: '',
        dayOfWeek: '',
        dayOfMonth: '',
    };
    /** IANA identifier the cron fields are read in. Always resolved by the API. */
    public timezone = 'UTC';
    public conditions: ScheduleCondition[] = [];
    public isActive = false;
    public isManaged = false;
    public userCanToggle = false;
    public isProcessing = false;
    public lastRunAt?: '';
    public nextRunAt = '';
    public createdAt = '';
    public updatedAt = '';

    get tasks(): ScheduleTask[] {
        return this.getRelationship('tasks');
    }

    getRouteName() {
        return 'schedule';
    }

    getRouteID() {
        return this.id.toString();
    }
}
